package images

import io.github.skeptick.libres.images.Image

public actual object ResImages
